import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import PropTypes from "prop-types";
import { get } from "lodash";

import Collapse from "./Collapse";
import { getOptionLabel } from "common/enums";
import { applicationTypes } from "common/constant";

const DcsDemandView = ({
  dcsDemand,
  isExpandable = true,
  applicationTypeId,
  t,
}) => {
  const {
    contractDemand,
    ultimateDemand,
    contractDemandUnit,
    ultimateDemandUnit,
    decreaseOfContractDemand,
    increaseOfContractDemand,
    increaceOrDecreaseOfContractDemandUnit,
    totalContractDemand,
    totalContractDemandUnit,
  } = dcsDemand;

  const isDemandExtensionApplication = useMemo(
    () => applicationTypes["Demand Extension"] === applicationTypeId,
    [applicationTypeId, applicationTypes]
  );

  const isDemandReductionApplication = useMemo(
    () => applicationTypes["Demand Reduction"] === applicationTypeId,
    [applicationTypeId, applicationTypes]
  );

  const fields = useMemo(
    () => [
      {
        name: "Existing Contract Demand",

        key: "contractDemand",
        isRequired: true,
        renderField: () =>
          contractDemand
            ? `${contractDemand} ${getOptionLabel(
                "unitOptions",
                contractDemandUnit
              )}`
            : "N/A",
        isVisible: isDemandExtensionApplication || isDemandReductionApplication,
      },
      {
        name: "Increase of Contract Demand",
        key: "increaseOfContractDemand",
        isRequired: true,
        renderField: () =>
          increaseOfContractDemand
            ? `${increaseOfContractDemand} ${getOptionLabel(
                "unitOptions",
                increaceOrDecreaseOfContractDemandUnit
              )}`
            : "N/A",
        isVisible: isDemandExtensionApplication,
      },
      {
        name: "Decrease of Contract Demand",
        key: "decreaseOfContractDemand",
        isRequired: true,
        renderField: () =>
          decreaseOfContractDemand
            ? `${decreaseOfContractDemand} ${getOptionLabel(
                "unitOptions",
                increaceOrDecreaseOfContractDemandUnit
              )}`
            : "N/A",
        isVisible: isDemandReductionApplication,
      },
      {
        name: "Total Contract Demand",
        key: "totalContractDemand",
        isRequired: true,
        renderField: () =>
          totalContractDemand
            ? `${totalContractDemand} ${getOptionLabel(
                "unitOptions",
                totalContractDemandUnit
              )}`
            : "N/A",
      },

      {
        name: "Ultimate Demand",
        key: "ultimateDemand",
        renderField: () =>
          ultimateDemand
            ? `${ultimateDemand} ${getOptionLabel(
                "unitOptions",
                ultimateDemandUnit
              )}`
            : "N/A",

        isRequired: true,
      },
    ],
    [dcsDemand]
  );

  return (
    <Collapse title="DCS Demand Details" isExpandable={isExpandable}>
      <Row className="d-flex mb-2">
        {fields.map(({ isVisible, name, key, isRequired, renderField }) => {
          const value = get(dcsDemand, key, "");
          if (typeof isVisible !== "boolean" || isVisible) {
            return (
              <Col key={key} lg={6} className="mb-1">
                <Row>
                  <Col md={5}>{t(name)}:</Col>
                  <Col
                    md={7}
                    className="fw-semibold"
                    style={{ wordBreak: "break-word" }}
                  >
                    {renderField
                      ? renderField(value)
                      : get(dcsDemand, key, null) ?? (isRequired ? "-" : "N/A")}
                  </Col>
                </Row>
              </Col>
            );
          }
        })}
      </Row>
    </Collapse>
  );
};

DcsDemandView.propTypes = {
  isExpandable: PropTypes.bool,
  dcsDemand: PropTypes.object,
  applicationTypeId: PropTypes.number,
  t: PropTypes.func,
};

export default withTranslation()(DcsDemandView);
